import { render } from "./Organization.vue?vue&type=template&id=2bfba7fb"
const script = {}

import exportComponent from "E:\\pay\\vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__